export default __webpack_public_path__ + "static/media/hht1_ep17_timeline_q05_b.42176976.png";